import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NonCashBenefitStatusIcon from '../nonCashBenefits/NonCashBenefitStatusIcon';

/** Shown while the employer is not a bikeleasing customer yet, so there is nothing the employee can do. */
export const BikeleasingSetupPending: React.FC = () => {
  const { t } = useTranslation('extensions');

  return (
    <Stack
      spacing={1}
      sx={{
        alignItems: 'center',
        p: 1,
      }}
    >
      <NonCashBenefitStatusIcon icon={HourglassEmptyIcon} />
      <Typography
        variant="h3"
        sx={{
          textAlign: 'center',
        }}
      >
        {t('bikeleasing_v2_benefit.setupPending.title')}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          textAlign: 'center',
        }}
      >
        {t('bikeleasing_v2_benefit.setupPending.description')}
      </Typography>
    </Stack>
  );
};

export default BikeleasingSetupPending;
